export default __webpack_public_path__ + "assets/3289b9482feb3722ce4e642c961fe8cf.png";